import React from "react";
import { useFormContext } from "react-hook-form";
import { InputText, PhoneNumberField } from "../../components";

function CustomerDetails() {
  const { control, getValues } = useFormContext();
  return (
    <>
      <div className="mb-8 space-y-3">
        <InputText
          label={"Customer name"}
          control={control}
          required
          name={"customer_info.name"}
          defaultValue={getValues("purchase_info.name_on_invoice")}
        />
        <InputText
          label={"Customer Email"}
          control={control}
          required
          name={"customer_info.email"}
        />
        <PhoneNumberField
          control={control}
          name="customer_info.phone"
          required
          label="Customer Phone"
        />
        <InputText
          label={"Customer Address"}
          control={control}
          required
          name={"customer_info.address"}
        />
        <InputText
          label={"City"}
          control={control}
          required
          name={"customer_info.city"}
        />
        <div className="grid min-[460px]:grid-cols-2 grid-cols-1 gap-4">
          <InputText
            label={"State"}
            control={control}
            required
            name={"customer_info.state"}
          />
          <InputText
            label={"Zip code"}
            control={control}
            required
            name={"customer_info.zip_code"}
          />
        </div>
      </div>
    </>
  );
}

export default CustomerDetails;
